// A pass through to prevent file links from breaking.
import reducer from 'nucleus-widgets/redux/modules/text';
export default reducer;
export * from 'nucleus-widgets/redux/modules/text';
